import React, { useEffect, useCallback } from 'react'

import { reactular } from '@vendhq/reactular'
import { ToastNotifications } from '@lightspeed/design-system-react'
import { useI18NToastMessage } from '../../../../functions/i18n-utils'

type NotifyFn = (
  category: 'success' | 'negative',
  messageKey: string,
  vars?: Record<string, any>
) => void

let notify: NotifyFn

export function wrToastSuccess(messageKey: string, vars?: Record<string, any>) {
  notify('success', messageKey, vars)
}

export function wrToastNegative(
  messageKey: string,
  vars?: Record<string, any>
) {
  notify('negative', messageKey, vars)
}

const WrToastNotifications: React.FC<{}> = () => {
  const getTranslatedMessage = useI18NToastMessage()

  const thisNotify = useCallback<NotifyFn>(
    (category, messageKey, vars) => {
      if (category === 'success') {
        ToastNotifications.success(getTranslatedMessage(messageKey, vars))
      } else if (category === 'negative') {
        ToastNotifications.negative(getTranslatedMessage(messageKey, vars))
      }
    },
    [getTranslatedMessage]
  )

  useEffect(() => {
    notify = thisNotify
  }, [thisNotify])

  return <ToastNotifications />
}

export const wrToastNotifications = reactular(
  WrToastNotifications,
  [],
  'reactWrapper'
)
